var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full h-full rounded-full flex items-center justify-center text-white",class:{'bg-green': _vm.assetType === 1,
              'bg-yellow': _vm.assetType === 2,
              'bg-text-label': _vm.assetType === 3,
              'bg-border': _vm.assetType === 4,
              'bg-border-hover': _vm.assetType === 5}},[(_vm.assetType === 1)?_c('IconStock'):(_vm.assetType === 2)?_c('IconBond'):(_vm.assetType === 3)?_c('IconFund'):(_vm.assetType === 5)?_c('IconOtherAsset'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }